import { RouterProvider } from 'react-router';
import { router } from './app/routes';
import { QueryProvider } from './shared/api-client';
import { AuthProvider } from './modules/auth/AuthContext';
import { TooltipProvider } from './shared/ui/components/tooltip';
import './shared/i18n/config';

export function App() {
  return (
    <QueryProvider>
      <AuthProvider>
        <TooltipProvider>
          <RouterProvider router={router} />
        </TooltipProvider>
      </AuthProvider>
    </QueryProvider>
  );
}
